<template lang="pug">
.addUnit__deviceInfo
  van-nav-bar(
    :title="$t('auxheat.title')"
    left-arrow
    @click-left="close"
    @click-right="checkForm")
    van-icon(name="save" slot="right")

  .main.addUnit__protocol
    //- Activar/Desactivar Calor Auxiliar
    .addUnit__auxheatSwitch
      span.addUnit__protocolSwitch__title(:class="{select:!auxheatenable}") {{ $t("auxheat.off") }}
      van-switch(v-model="auxheatenable")
      span.addUnit__protocolSwitch__title(:class="{select:auxheatenable}") {{ $t("auxheat.on") }}

    van-cell-group.addUnit__popup__cell-group
      van-cell.van-cell--value-select(
        :class="{disabled: !auxheatenable}"
        :title="$t('auxheat.ton')"
        :value="ton"
        @click="openSetTOnOff(ton, 'ton')")

      van-cell.van-cell--value-select(
        :class="{disabled: !auxheatenable}"
        :title="$t('auxheat.toff')"
        :value="toff"
        @click="openSetTOnOff(toff, 'toff')")

      van-cell.van-cell--value-select(
        :class="{disabled: !auxheatenable}"
        :title="$t('auxheat.tdelay')"
        :value="tdelay"
        @click="openSetTdelay(tdelay)")

      van-switch-cell(
        v-if="lockoutenable !== undefined && lockoutenable !== null"
        :class="{disabled: !auxheatenable}"
        :disabled="!auxheatenable",
        v-model="lockoutenable",
        :title="$t('auxheat.lockoutenable')")

      van-cell.van-cell--value-select(
        v-if="lockoutenable !== undefined && lockoutenable !== null"
        :class="{disabled: !auxheatenable || !lockoutenable}"
        :title="$t('auxheat.lockouttemp')"
        :value="lockouttemp"
        @click="openSetLockoutTemp(lockouttemp)")

      van-cell.van-cell--value-select(
        :class="{disabled: disableExtHeatSource()}"
        :title="$t('auxheat.extheatsource')",
        :value="extheatsource"
        @click="openSetExtheatsource(extheatsource)")

</template>

<script>
import BluetoothService from '@/services/bluetooth.service';
import { getErrorId } from '@/services/error.service';

export default {
  props: {
    device: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      auxheatenable: null,
      ton: '',
      toff: '',
      tdelay: '',
      lockoutenable: null,
      lockouttemp: '',
      extheatsource: '',
      tonOptions: [
        { text: '-7.2 ºF (-4.0 ºC)', value: -40 },
        { text: '-6.3 ºF (-3.5 ºC)', value: -35 },
        { text: '-5.4 ºF (-3.0 ºC)', value: -30 },
        { text: '-4.5 ºF (-2.5 ºC)', value: -25 },
        { text: '-3.6 ºF (-2.0 ºC)', value: -20 },
        { text: '-2.7 ºF (-1.5 ºC)', value: -15 },
      ],
      toffOptions: [
        { text: '-3.6 ºF (-2.0 ºC)', value: -20 },
        { text: '-2.7 ºF (-1.5 ºC)', value: -15 },
        { text: '-1.8 ºF (-1.0 ºC)', value: -10 },
        { text: '-0.9 ºF (-0.5 ºC)', value: -5 },
        { text: '0 ºF (0 ºC)', value: 0 },
        { text: '0.9 ºF (0.5 ºC)', value: 10 },
      ],
      tdelayOptions: [
        { text: '0 min', value: 0 },
        { text: '5 min', value: 5 },
        { text: '10 min', value: 10 },
        { text: '15 min', value: 15 },
        { text: '20 min', value: 20 },
        { text: '25 min', value: 25 },
        { text: '30 min', value: 30 },
      ],
      lockouttempOptions: [
        { text: '0 ºF (-17.8 ºC)', value: -178 },
        { text: '5 ºF (-15 ºC)', value: -150 },
        { text: '10 ºF (-12.2 ºC)', value: -122 },
        { text: '15 ºF (-9.4 ºC)', value: -94 },
        { text: '20 ºF (-6.7 ºC)', value: -67 },
        { text: '25 ºF (-3.9 ºC)', value: -39 },
        { text: '30 ºF (-1.1 ºC)', value: -11 },
        { text: '35 ºF (1.7 ºC)', value: 17 },
        { text: '40 ºF (4.4 ºC)', value: 44 },
        { text: '45 ºF (7.2 ºC)', value: 72 },
        { text: '50 ºF (10 ºC)', value: 100 },
        { text: '55 ºF (12.8 ºC)', value: 128 },
        { text: '60 ºF (15.6 ºC)', value: 156 },
        { text: '65 ºF (18.3 ºC)', value: 183 },
      ],
      extheatsourceOptions: [
        { text: this.$i18n.t('auxheat.duct'), value: 0 },
        { text: this.$i18n.t('auxheat.radiant'), value: 1 },
      ],
    };
  },

  methods: {
    /**
     * Desabilita el campo de la ventilación si no existe, sino asigna el valor del calor auxiliar
     */
    disableExtHeatSource() {
      let disable = false;

      if (this.device.auxheat_extheatsource === undefined) {
        disable = true;
      } else {
        disable = !this.auxheatenable;
      }

      return disable;
    },

    /**
     * Devuelve el texto de la Temperatura Delta
     */
    getTOnOffText(value, type) {
      let option = {};
      if (type === 'ton') {
        option = this.tonOptions.find(item => item.value === value);
      } else if (type === 'toff') {
        option = this.toffOptions.find(item => item.value === value);
      }
      return option && option.text ? option.text : '';
    },

    /**
     * Devuelve el valor de la Temperatura Delta
     */
    getTOnOffValue(text, type) {
      let option = {};
      if (type === 'ton') {
        option = this.tonOptions.find(item => item.text === text);
      } else if (type === 'toff') {
        option = this.toffOptions.find(item => item.text === text);
      }
      return option.value;
    },

    /**
     * Devuelve el texto del Tiempo de Retraso
     */
    getTdelayText(value) {
      const option = this.tdelayOptions.find(item => item.value === value);
      return option && option.text ? option.text : '';
    },

    /**
     * Devuelve el valor del Tiempo de Retraso
     */
    getTdelayValue(text) {
      const option = this.tdelayOptions.find(item => item.text === text);
      return option.value;
    },

    /**
     * Devuelve el texto de la Temperatura de Bloqueo
     */
    getLockoutTempText(value) {
      const option = this.lockouttempOptions.find(item => item.value === value);
      return option && option.text ? option.text : '';
    },

    /**
     * Devuelve el valor de la Temperatura de Bloqueo
     */
    getLockoutTempValue(text) {
      const option = this.lockouttempOptions.find(item => item.text === text);
      return option.value;
    },

    /**
     * Devuelve el texto del Tipo de ventilacion
     */
    getExtheatsourceText(value) {
      const option = this.extheatsourceOptions.find(item => item.value === value);
      return option && option.text ? option.text : '';
    },

    /**
     * Devuelve el valor del Tipo de ventilacion
     */
    getExtheatsourceValue(text) {
      const option = this.extheatsourceOptions.find(item => item.text === text);
      return option.value;
    },

    /**
     * Compruebo si los datos del formulario son válidos
     */
    checkForm() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.saveAuxheat();
        }
      });
    },

    /**
     * Muestra el selector de temperatura delta TOn y TOff
     */
    openSetTOnOff(value, type) {
      if (this.auxheatenable) {
        // let itemsTOnOff;
        let limitItemsTOnOff;
        let arrayOptions = [];

        if (type === 'ton') {
          limitItemsTOnOff = this.getTOnOffValue(this.toff, 'toff');
          arrayOptions = this.tonOptions.slice(0, (limitItemsTOnOff + 25) / 5);
        } else if (type === 'toff') {
          limitItemsTOnOff = this.getTOnOffValue(this.ton, 'ton');
          arrayOptions = this.toffOptions.slice((limitItemsTOnOff + 40) / 5, 6);
        }
        const itemsTOnOff = [[arrayOptions]];

        const configAlgortihm = {
          title: this.$i18n.t(`auxheat.${type}`),
          items: itemsTOnOff,
          positiveButtonText: this.$i18n.t('fallback.done'),
          negativeButtonText: this.$i18n.t('fallback.cancel'),
          theme: 'dark',
          displayKey: 'text',
          defaultItems: {
            0: `${value}`,
          },
        };

        window.SelectorCordovaPlugin.showSelector(configAlgortihm, result => {
          if (configAlgortihm.title === this.$i18n.t('auxheat.ton')) {
            this.ton = arrayOptions[result[0].index].text;
          } else if (configAlgortihm.title === this.$i18n.t('auxheat.toff')) {
            this.toff = arrayOptions[result[0].index].text;
          }
        });
      }
    },

    /**
     * Muestra el selector de tiempo de retraso
     */
    openSetTdelay(value) {
      if (this.auxheatenable) {
        const configTdelay = {
          title: this.$i18n.t('auxheat.tdelay'),
          items: [[this.tdelayOptions]],
          positiveButtonText: this.$i18n.t('fallback.done'),
          negativeButtonText: this.$i18n.t('fallback.cancel'),
          theme: 'dark',
          displayKey: 'text',
          defaultItems: {
            0: `${value}`,
          },
        };

        window.SelectorCordovaPlugin.showSelector(configTdelay, result => {
          this.tdelay = this.tdelayOptions[result[0].index].text;
        });
      }
    },

    /**
     * Muestra el selector de tiempo de retraso
     */
    openSetLockoutTemp(value) {
      if (this.auxheatenable && this.lockoutenable) {
        const configLockoutTemp = {
          title: this.$i18n.t('auxheat.lockouttemp'),
          items: [[this.lockouttempOptions]],
          positiveButtonText: this.$i18n.t('fallback.done'),
          negativeButtonText: this.$i18n.t('fallback.cancel'),
          theme: 'dark',
          displayKey: 'text',
          defaultItems: {
            0: `${value}`,
          },
        };

        window.SelectorCordovaPlugin.showSelector(configLockoutTemp, result => {
          this.lockouttemp = this.lockouttempOptions[result[0].index].text;
        });
      }
    },

    /**
     * Muestra el selector de tipo de ventilacion
     */
    openSetExtheatsource(value) {
      if (this.auxheatenable && this.device.auxheat_extheatsource !== undefined) {
        const configExtheatsource = {
          title: this.$i18n.t('auxheat.extheatsource'),
          items: [[this.extheatsourceOptions]],
          positiveButtonText: this.$i18n.t('fallback.done'),
          negativeButtonText: this.$i18n.t('fallback.cancel'),
          theme: 'dark',
          displayKey: 'text',
          defaultItems: {
            0: `${value}`,
          },
        };

        window.SelectorCordovaPlugin.showSelector(configExtheatsource, result => {
          this.extheatsource = this.extheatsourceOptions[result[0].index].text;
        });
      }
    },

    /**
     * Guarda los datos
     */
    async saveAuxheat() {
      try {
        // Compruebo si hay una petición en curso,
        // si la hay, no hago nada
        if (this.isLoading) return;

        // Muestro el loader
        this.$toast.loading({
          duration: 0,
          mask: true,
          message: this.$i18n.t('general.loading'),
        });

        // Inicializo valores
        this.isLoading = true;

        // Preparo los datos
        const data = {};
        data.auxheat_enable = this.auxheatenable;
        data.auxheat_ton = this.getTOnOffValue(this.ton, 'ton');
        data.auxheat_toff = this.getTOnOffValue(this.toff, 'toff');
        data.auxheat_tdelay = this.getTdelayValue(this.tdelay);
        data.auxheat_lockoutenable = this.lockoutenable;
        if (this.lockouttemp) {
          data.auxheat_lockouttemp = this.getLockoutTempValue(this.lockouttemp);
        }

        if (this.extheatsource) {
          data.auxheat_extheatsource = this.getExtheatsourceValue(this.extheatsource);
        }

        console.log(data);

        // Realizo la petición
        const dataResult = await BluetoothService.setDeviceParam(
          this.device.id,
          JSON.stringify(data)
        );

        // Set values in the model device
        this.device.auxheat_enable = dataResult.params.auxheat_enable;
        this.device.auxheat_ton = dataResult.params.auxheat_ton;
        this.device.auxheat_toff = dataResult.params.auxheat_toff;
        this.device.auxheat_tdelay = dataResult.params.auxheat_tdelay;
        this.device.auxheat_lockoutenable = dataResult.params.auxheat_lockoutenable;
        if (this.lockouttemp) {
          this.device.auxheat_lockouttemp = dataResult.params.auxheat_lockouttemp;
        }
        if (this.extheatsource) {
          this.device.auxheat_extheatsource = dataResult.params.auxheat_extheatsource;
        }

        this.$toast.clear();
        this.$toast.success({
          mask: true,
          message: this.$i18n.t('auxheat.success'),
        });
        console.log('result: ', dataResult);
        this.close(dataResult.params);
      } catch (error) {
        console.log(error);
        // Obtengo el error
        getErrorId(error);

        this.$toast.clear();
        this.$toast.fail({ mask: true, message: this.$i18n.t('auxheat.error') });
      } finally {
        this.isLoading = false;
      }
    },

    /**
     * Cierra este componente
     */
    close(data) {
      this.$emit('close', data);
    },
  },

  mounted() {
    this.auxheatenable =
      this.device.auxheat_enable !== undefined ? this.device.auxheat_enable : null;
  },
  created() {
    console.log('this: ', this);
    this.ton = this.getTOnOffText(this.device.auxheat_ton, 'ton');
    this.toff = this.getTOnOffText(this.device.auxheat_toff, 'toff');
    this.tdelay = this.getTdelayText(this.device.auxheat_tdelay);
    this.lockoutenable = this.device.auxheat_lockoutenable;
    if (this.device.auxheat_lockouttemp !== undefined && this.device.auxheat_lockouttemp !== null) {
      this.lockouttemp = this.getLockoutTempText(this.device.auxheat_lockouttemp);
    } else {
      // console.log('LOCKOUTTEMPOPTIONS', this.lockouttempOptions);
      this.lockouttemp = this.lockouttempOptions[0].text;
    }
    // this.lockouttemp = this.getLockoutTempText(this.device.auxheat_lockouttemp);
    if (
      this.device.auxheat_extheatsource !== undefined &&
      this.device.auxheat_extheatsource !== null
    ) {
      // console.log('EXTHEATSOURCE OK', this.device.auxheat_extheatsource, this.extheatsourceOptions);
      this.extheatsource = this.getExtheatsourceText(this.device.auxheat_extheatsource);
    } else {
      // console.log('EXTHEATSOURCE', this.extheatsourceOptions);
      this.extheatsource = this.extheatsourceOptions[1].text;
    }
  },
};
</script>
